const cartoBasemapKey =
  process.env.REACT_APP_CARTO_BASEMAP_KEY?.trim() ?? '';

if (!cartoBasemapKey) {
  console.warn('REACT_APP_CARTO_BASEMAP_KEY no está configurada');
}

export const CARTO_BASEMAP_URL =
  `https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=${encodeURIComponent(cartoBasemapKey)}`;

export const CARTO_ATTRIBUTION =
  '© OpenStreetMap contributors • © CARTO';
